const product = {
  product: "製品", // translated
  products: "製品", // translated
  information: "情報", // translated
  additionalInformation: "追加情報", // translated
  contactUs: "お問い合わせ", // translated
  contactUsText: "ツアーをカスタマイズしたい場合、またはその他の質問がありますか?", // translated
  dropUsAnEmail: "メールでお問い合わせください", // translated
  viewLess: "表示を減らす", // translated
  viewMore: "もっと見る", // translated
  less: "少ない", // translated
  more: "もっと", // translated
  highlights: "ハイライト", // translated
  inclusions: "以下を含む", // translated
  exclusions: "除外事項", // translated
  pleaseWait: "お待ちください...", // translated
  tourType: "ツアータイプ", // translated
  search: "検索", // translated
  available: "利用可能", // translated
  availableTours: "利用可能なツアー", // translated
  sortBy: "並べ替え", // translated
  priceLowToHigh: "価格: 安いものから高いものまで", // translated
  priceHighToLow: "価格: 高から低まで", // translated
  mostPopular: "最も人気のある", // translated
  roomOnly: "部屋のみ", // translated
  bedAndBreakfast: "ベッド＆ブレックファスト", // translated
  halfBoard: "2食付き", // translated
  fullBoard: "三食付き", // translated
  allInclusive: "オールインクルーシブ", // translated
  viewDetails: "詳細を見る", // translated
  close: "近い", // translated
  at: "で", // translated
  person: "人", // translated
  cancellationPolicy: "取り消し規約", // translated
  cancellationIs: "キャンセルは", // translated
  to: "に", // translated
  bookingRemarks: "予約に関する備考", // translated
  totalPrice: "合計金額", // translated
  back: "戻る", // translated
  bookNow: "今予約する", // translated
  minutes: "分", // translated
  visitDuration: "訪問期間", // translated
  itinerary: "旅程", // translated
  airportToHotel: "空港からホテルまで", // translated
  hotelToAirport: "ホテルから空港まで", // translated
  details: "詳細", // translated
  servicesDetails: "サービス詳細", // translated
  services: "サービス", // translated
  day: "日", // translated
  next: "次", // translated
  nextStep: "次のステップ", // translated
  skip: "スキップ", // translated
  remarks: "備考", // translated
  optional: "オプション", // translated
  guests: "ゲスト", // translated
  payment: "支払い", // translated
  pickup: "選び出す", // translated
  featuredPackage: "注目のパッケージ", // translated
  flights: "フライト", // translated
  accommodation: "宿泊施設", // translated
  transfers: "転送", // translated
  tours: "ツアー", // translated
  experiences: "体験談", // translated
  featuredTour: "注目のツアー", // translated
  From: "から", // translated
  Accommodation: "宿泊施設", // translated
  approxDuration: "約間隔", // translated
  travellerInformation: "旅行者情報", // translated
  bookingOverview: "予約概要", // translated
  checkout: "チェックアウト", // translated
  paymentFailed: "支払いに失敗しました", // translated
  paymentSuccess: "支払い成功", // translated
  night: "夜", // translated
  nights: "夜", // translated
  viewEscapes: "エスケープを見る", // translated
  viewExperience: "エクスペリエンスを見る", // translated
  escapeType: "エスケープタイプ", // translated
  adultsOnly: "大人だけ", // translated
  totalDuration: "合計所要時間", // translated
  options: "オプション", // translated
  departingAirport: "空港出発", // translated
  childrenAreNotAllowedInThisTour: "このツアーにはお子様は参加できません", // translated
};



export default product;
